import React, { Component } from 'react';
import { DISPATCH_ID } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import AreYouAgreeModal from './AreYouAgreeModal';


class LimitPoinstCardModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeModalLastDate = async () => {
        const { GetAllConfiguration, updatePointsCardModal } = this.props;
        updatePointsCardModal(false)
        $('#limitPoinstCard').modal('hide');
        await GetAllConfiguration()
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#limitPoinstCard').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            PointsCardModel,
            change_LastDate,
            activeShowAreYouAgreeModal_LastDate,
            showAreYouAgreeModal_LastDate,
            CloseShowAreYouAgreeModal_LastDate,
            Update_LastDate,
        } = this.props;

        return (

            <>
                <div className="modal fade bd-example-modal-md modal-open scroll"
                    id="limitPoinstCard"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">

                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    Configuración Vigencia de Puntos
                                </h4>
                                <button type="button" className="close" onClick={this.closeModalLastDate} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha límite para canje de puntos</span>
                                                            </div>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                id="txtDatePoints"
                                                                aria-label="Fecha de puntos"
                                                                placeholder="Selecciona una fecha"
                                                                autocomplete="on"
                                                                onChange={change_LastDate}
                                                                value={PointsCardModel.last_reset_date ? PointsCardModel.last_reset_date : ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalLastDate} >Cerrar</button>
                                <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgreeModal_LastDate} >Guardar Cambios</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showAreYouAgreeModal_LastDate &&
                    <AreYouAgreeModal
                        mensaje={`¿Estás seguro que deseas actualizar la fecha límite?`}
                        accept={Update_LastDate}
                        cancel={CloseShowAreYouAgreeModal_LastDate}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LimitPoinstCardModal);